import React from "react";
import { useDOCOnlineContext } from "./DOCOnlineContext";
import { showError } from "../../services/ModalService";
import ModalContainer from "../../containers/Modal/ModalContainer";
import { useTranslation } from "react-i18next";

const ConsentModal = () => {
  const {
    showConsentModal,
    setShowConsentModal,
    docOnline,
    setDocOnline,
    AcceptRGPD,
    docOnlineRGPDMessage
  } = useDOCOnlineContext();
  const { t } = useTranslation();

  function submitConsent() {
    if (!docOnline.isAcceptedConsent) {
      showError(t("You have to accept the agreement."));
    } else {
      AcceptRGPD();
      setShowConsentModal(false);
    }
  }

  function onChangeConsent(value) {
    let _docOnline = { ...docOnline };
    _docOnline["isAcceptedConsent"] = value;
    setDocOnline(_docOnline);
  }

  return (
    <ModalContainer
      modalTitle={t("Consent")}
      isOpen={showConsentModal}
      closeModal={() => setShowConsentModal(false)}
      submitButtonTitle={t("Done")}
      submitButtonType="button"
      submitButtonAction={() => {
        submitConsent();
      }}
    >
      <div className="card card-consent-modal">
        <div className="card-body overflow-auto">
          <div className="card-text" dangerouslySetInnerHTML={{ __html: docOnlineRGPDMessage.message }} />
        </div>
      </div>
      <div className="mt-4">
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="consentRadioButton"
            id="radioIAgree"
            value={true}
            onClick={() => {
              onChangeConsent(true);
            }}
          />
          <label className="form-check-label" htmlFor="radioIAgree">
            {t("I agree")}
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="consentRadioButton"
            id="radioIdoNotAgree"
            value={false}
            onClick={() => {
              onChangeConsent(false);
            }}
          />
          <label className="form-check-label" htmlFor="radioIdoNotAgree">
            {t("I do not agree")}
          </label>
        </div>
      </div>
    </ModalContainer>
  );
};

export default ConsentModal;
